import axiosHttp from "services/axiosHttp";
import { REWARD_BASE_URL } from "configs/AppConfig";
import moment from "moment";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

// action
export const fetchCashReportExcelExport = createAsyncThunk("fetchCashReportExcelExport", async ({ filters }, { rejectWithValue }) => {
    let startDate = "";
    let endDate = "";

    if (filters?.range?.length === 2) {
        startDate = moment(filters.range[0].$d).format("YYYY-MM-DD");
        endDate = moment(filters.range[1].$d).format("YYYY-MM-DD");
    }

    const params = new URLSearchParams({
        startDate: startDate,
        endDate: endDate,
        channel: filters?.channel ?? "",
        terminal: filters?.terminal ?? "",
        cashierUUID: filters?.cashierUUID ?? "",
        payment_method: filters?.payment_method ?? "",
        customerType: filters?.customer_type ?? "",
    });

    try {
        const response = await axiosHttp.get(`${REWARD_BASE_URL}download-cash-report?${params}`, {
            responseType: "blob",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "cash_report_export.xlsx");
        document.body.appendChild(link);
        link.click();

        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);

        return { success: true };
    } catch (error) {
        return rejectWithValue(error.response?.message || "Something went wrong");
    }
});

const CashReportExportSlice = createSlice({
    name: "CashReportExportSlice",
    initialState: {
        isLoading: false,
        data: null,
        error: null,
    },

    extraReducers: (builder) => {
        builder.addCase(fetchCashReportExcelExport.pending, (state) => {
            state.isLoading = true;
        });

        builder.addCase(fetchCashReportExcelExport.fulfilled, (state) => {
            state.isLoading = false;
        });

        builder.addCase(fetchCashReportExcelExport.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload || "Unknown error occurred";
        });
    },
});

export default CashReportExportSlice.reducer;